    export const copyUrl = (val) => {
        navigator.clipboard.writeText(val);
    }